import React from 'react'
import NextStep from './NextStep'
import SuccessPage from '../Components/SuccessPage'
import MoneyInput from '../Components/MoneyInput'
import BankSelect from '../Components/BankSelect'
import UserBankSelect from '../Components/UserBankSelect'
import OldBank from './OldBank'
import TipsView from '../Components/TipsView'
import SubmitBtn from '../Components/SubmitBtn'
import BankNone from '../Components/BankNone'
import QDCon from '$Deposits/Components/QD'


class QD extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {


        return (
            <div className='methodsActive'>
                <QDCon
                    BankNone={BankNone}
                    TipsView={TipsView}
                    MoneyInput={MoneyInput}
                    UserBankSelect={UserBankSelect}
                    BankSelect={BankSelect}
                    OldBankLine={(propCon) => {
                        const { onChange, msg } = propCon
                        return (
                            <div
                                className='openOldAccount'
                                data-CN="存款至舊帳戶"
                                onClick={onChange}
                            >
                                {msg}
                            </div>
                        )
                    }}
                    SubmitBtn={SubmitBtn}
                    NextStep={NextStep}
                    SuccessPage={SuccessPage}
                    OldBank={OldBank}
                />

            </div>

        );
    }
}

export default QD


